import { Component, inject, signal } from '@angular/core';
import { form, FormField, submit } from '@angular/forms/signals';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { prefix } from '@validators';

@Component({
  selector: 'app-attachment-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  imports: [
    FormField,
    MatButtonModule,
    MatSlideToggleModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatSelectModule,
    MatDialogModule,
  ],
})
export class AttachmentSearchComponent {
  dialogRef = inject<MatDialogRef<AttachmentSearchComponent>>(MatDialogRef);

  filterForm = form(signal<{
    search: string;
    from: string;
    until: string;
    prefix: string;
    disablePrefix: boolean;
    sort: string | null;
    order: string | null;
  }>({
    search: '',
    from: '',
    until: '',
    prefix: '',
    disablePrefix: true,
    sort: null,
    order: null,
  }), (schemaPath) => {
    prefix(schemaPath.prefix);
  });

  constructor() {
    const data = inject<{
      search?: string;
      from?: string;
      until?: string;
      prefix?: string;
      order?: string;
    }>(MAT_DIALOG_DATA);

    if (data.search) {
      this.filterForm.search().value.set(data.search);
    }

    if (data.from) {
      this.filterForm.from().value.set(data.from);
    }

    if (data.until) {
      this.filterForm.until().value.set(data.until);
    }

    if (data.prefix) {
      this.filterForm.prefix().value.set(data.prefix);
      this.filterForm.disablePrefix().value.set(false);
    }

    if (data.order) {
      const parts = data.order.split(':');
      if (parts.length == 2) {
        this.filterForm.sort().value.set(parts[0]);
        this.filterForm.order().value.set(parts[1]);
      }
    }
  }

  public submit(event: Event) {
    event.preventDefault();

    submit(this.filterForm, async () => {
      const sort = this.filterForm.sort().value();
      const order = this.filterForm.order().value();

      this.dialogRef.close({
        search: this.filterForm.search().value() || undefined,
        from: this.filterForm.from().value() || undefined,
        until: this.filterForm.until().value() || undefined,
        prefix: this.filterForm.disablePrefix().value()
          ? ''
          : this.filterForm.prefix().value(),
        order: sort || order
          ? `${sort || 'created'}:${order || 'desc'}`
          : undefined,
      });
    });
  }
}
